
export enum AddOnTypeName {
    "Recipe cost",
    "Sugar alcohols",
    "Field Eagle",
    "Wellness Module",
    "Allergen AI"
}